import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardSetupMessageHandler } from '../../hooks/useYardSetupMessageHandler'
import { IBayFormData, IRowFormData } from '../../models/yard-setup.model'
import {
  YardBlockEditSectionDialogType,
  YardBlockViewStore,
} from '../../stores/nodes/yard-block.view-store'
import { AxisNameForm } from './AxisNameForm'

interface Props {
  yardBlockViewStore: YardBlockViewStore
}

export const YardBlockRenameSectionDialog = observer(({ yardBlockViewStore }: Props) => {
  const { t } = useTranslate()
  const { getExceptionMessage, getBlockSuccessMessage } = useYardSetupMessageHandler()

  const dialogType = yardBlockViewStore.renameSectionDialogType

  const onSubmit = async (data: IBayFormData | IRowFormData) => {
    try {
      if (dialogType === YardBlockEditSectionDialogType.Bay) {
        await yardBlockViewStore.renameBay(data as IBayFormData)
      } else if (dialogType === YardBlockEditSectionDialogType.Row) {
        await yardBlockViewStore.renameRow(data as IRowFormData)
      }
      appStore.setShowAlert('success', getBlockSuccessMessage(!!yardBlockViewStore.editingId))
      yardBlockViewStore.closeRenameSectionDialog()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  let form = null
  if (dialogType === YardBlockEditSectionDialogType.Bay) {
    form = (
      <AxisNameForm
        id='rename-section-form'
        label={t('bayName', 'Bay name')}
        initialValue={
          yardBlockViewStore.focusedYardBlock?.bayNames[
            (yardBlockViewStore.editingBayIndex ?? 0) - 1
          ]
        }
        onSubmit={onSubmit}
      />
    )
  } else if (dialogType === YardBlockEditSectionDialogType.Row) {
    form = (
      <AxisNameForm
        id='rename-section-form'
        label={t('rowName', 'Row name')}
        initialValue={
          yardBlockViewStore.focusedYardBlock?.rowNames[
            (yardBlockViewStore.editingRowIndex ?? 0) - 1
          ]
        }
        onSubmit={onSubmit}
      />
    )
  }

  return (
    <ConfirmationDialog
      open={yardBlockViewStore.isRenameSectionDialogOpen}
      title={
        dialogType === YardBlockEditSectionDialogType.Bay
          ? t('renameBay', 'Rename bay')
          : t('renameRow', 'Rename row')
      }
      primaryActionText={t('save', 'Save')}
      closeLabel={t('cancel', 'cancel')}
      formId='rename-section-form'
      onClose={() => yardBlockViewStore.closeRenameSectionDialog()}
      onConfirm={() => {
        return
      }}
      maxWidth='xs'
    >
      {form}
    </ConfirmationDialog>
  )
})
